import { render, staticRenderFns } from "./PortalNotificationBody.vue?vue&type=template&id=5feb6438&scoped=true&"
import script from "./PortalNotificationBody.vue?vue&type=script&lang=ts&"
export * from "./PortalNotificationBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb6438",
  null
  
)

export default component.exports